import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { version } from '../../../package.json';

import styles from './Version.module.scss';

const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
};

const clearAPIGwLocalStorage = () =>
  window.localStorage.removeItem('cureoscity_apigw_url');

const devClear = () => {
  clearAPIGwLocalStorage();
  deleteAllCookies();
  window.location.reload();
};

export const Version = ({ appearance, className, alignment }) => (
  <span
    id="portal-version"
    className={classnames(
      styles.version,
      styles[appearance],
      className,
      styles[alignment]
    )}
  >
    <>
      {process.env.NODE_ENV === 'development' && (
        <div className={styles.devPanel}>
          Mocked: {process.env.USE_MOCKS || 'false'}
          <br />
          API: {window.localStorage.cureoscity_apigw_url || 'none - mocked'}
          <br />
          <a href="#" onClick={devClear}>
            Clear
          </a>
          <br />
          v{version}
        </div>
      )}
    </>
    v{version}
  </span>
);

Version.propTypes = {
  appearance: PropTypes.oneOf(['primary', 'secondary', 'secondary-left']),
  alignment: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string
};

Version.defaultProps = {
  appearance: 'primary',
  alignment: 'left',
  className: ''
};
